
import React, { useState } from 'react';
import { Share2, ThumbsUp, ThumbsDown } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { Button } from '@/components/ui/button';
import SocialSharePanel from '../SocialSharePanel';

export interface VideoPlayerProps {
  id: number | string;
  title?: string;
  video_path?: string;
  videoUrl?: string; // Adding this prop to support both naming conventions
  avatar_path?: string;
  emotion?: any;
  location?: any;
  created_at?: string;
  user_id?: string;
  merchant_id?: string | null;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ 
  id, 
  title, 
  video_path, 
  videoUrl,
  avatar_path, 
  emotion, 
  location, 
  created_at,
  user_id,
  merchant_id
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showSharePanel, setShowSharePanel] = useState(false);
  
  // Use either video_path or videoUrl prop
  const videoSrc = videoUrl || video_path || '';
  
  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };
  
  const handleShare = () => {
    setShowSharePanel(!showSharePanel);
  };
  
  const formattedDate = created_at 
    ? new Date(created_at).toLocaleDateString() 
    : '';

  return (
    <div className="relative bg-gray-900 rounded-lg overflow-hidden shadow-lg">
      <div className="aspect-[9/16] bg-black">
        <video 
          src={videoSrc} 
          className="w-full h-full object-contain"
          controls
          onClick={handlePlayPause}
          playsInline
        />
      </div>
      
      <div className="p-3">
        <h3 className="font-semibold text-lg text-white">{title || "Untitled"}</h3>
        {formattedDate && (
          <p className="text-xs text-gray-400">{formattedDate}</p>
        )}
        
        <div className="flex justify-between items-center mt-2">
          <Button 
            variant="ghost" 
            size="sm"
            onClick={handleShare}
            className="text-gray-300 hover:text-white"
          >
            <Share2 className="w-4 h-4 mr-1" />
            Share
          </Button>
        </div>
        
        {emotion?.dominantEmotion && (
          <div className="mt-2 text-xs text-gray-400">
            Emotion: {emotion.dominantEmotion}
          </div>
        )}
      </div>
      
      {showSharePanel && (
        <div className="absolute bottom-full mb-2 right-0 z-10">
          <SocialSharePanel
            videoId={typeof id === 'string' ? parseInt(id, 10) : id}
            userId={user_id}
            videoUrl={videoSrc}
            title={title || "Check out my video!"}
            description={"Recorded with emotion: " + (emotion?.dominantEmotion || "neutral")}
            merchantId={merchant_id || undefined}
          />
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
